module.exports = __webpack_public_path__ + "static/media/masterpass.5cefad32.gif";